<p class="selected-address" [ngClass]="isDecisionPoint ? 'decision-point' : ''" *ngIf="_delivery.addressDefined">
  <span> {{label}}</span><br />
  {{ address}}
</p>


